import { render, staticRenderFns } from "./jinqifahui.vue?vue&type=template&id=9feac29c&scoped=true"
import script from "./jinqifahui.vue?vue&type=script&lang=js"
export * from "./jinqifahui.vue?vue&type=script&lang=js"
import style0 from "./jinqifahui.vue?vue&type=style&index=0&id=9feac29c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9feac29c",
  null
  
)

export default component.exports